import { render, staticRenderFns } from "./check-result-dialog.vue?vue&type=template&id=3cbe48e0&scoped=true"
import script from "./check-result-dialog.vue?vue&type=script&lang=js"
export * from "./check-result-dialog.vue?vue&type=script&lang=js"
import style0 from "./check-result-dialog.vue?vue&type=style&index=0&id=3cbe48e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbe48e0",
  null
  
)

export default component.exports